import { Box, Typography } from '@mui/material';
import { landingContent } from '../landing-content';
import { landingPalette } from '../landing-theme';
import { CapabilityCard } from './CapabilityCard';
import { LandingEyebrow } from './LandingEyebrow';
import { SectionShell } from './SectionShell';

/** "What Flex can do": section heading plus the 3x2 grid of capability tiles. */
export function CapabilityGrid() {
  const { capabilities } = landingContent;
  const hairline = `1px solid ${landingPalette.line}`;

  return (
    <SectionShell sx={{ py: { xs: 8, md: 12 } }}>
      <Box sx={{ maxWidth: 720, mb: 5 }}>
        <LandingEyebrow>{capabilities.eyebrow}</LandingEyebrow>
        <Typography variant="h2" component="h2" sx={{ mb: 3 }}>
          {capabilities.title}
        </Typography>
        <Typography sx={{ color: '#bfbfbf', fontSize: '1.1rem' }}>
          {capabilities.description}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
          borderTop: hairline,
          borderLeft: hairline,
          '& > *': { borderRight: hairline, borderBottom: hairline },
        }}
      >
        {capabilities.cards.map((capability) => (
          <CapabilityCard key={capability.number} capability={capability} />
        ))}
      </Box>
    </SectionShell>
  );
}
